// extracted by mini-css-extract-plugin
export default {"mainContainer":"mainContainer__uwAlce0v","catalogContainer":"catalogContainer__S1MQogS_"};